import React, { FC } from "react";
import { Select } from "antd";
import { getYearOptions } from "./helper";

interface Props {
  selectedYear: number;
  setSelectedYear: (year: number) => void;
}

const YearDropdown: FC<Props> = ({ selectedYear, setSelectedYear }) => (
  <div style={{ marginBottom: '16px' }}>
    <label style={{ marginRight: '12px', fontWeight: 600, fontSize: '15px', color: '#374151' }}>
      Year:
    </label>
    <Select
      value={selectedYear}
      onChange={(value) => setSelectedYear(value)}
      style={{ width: 120, height: 40 }}
      size="large"
    >
      {getYearOptions().map((year) => (
        <Select.Option key={year} value={year}>
          <span style={{ fontSize: '15px' }}>{year}</span>
        </Select.Option>
      ))}
    </Select>
  </div>
);

export default YearDropdown;

